














import { Vue, Component, Prop } from 'vue-property-decorator';
import { isNewArticle } from './utils';

@Component
export default class ArticleNewBadge extends Vue {
  @Prop({ required: true })
  private readonly publishedAt!: string;

  private get isNew(): boolean {
    return isNewArticle(this.publishedAt);
  }
}
